export default __webpack_public_path__ + "static/media/webmoney.7e67a1bc.png";